module.exports = __webpack_public_path__ + "static/media/model_3.32018954.png";